import React from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import { FacebookShareButton, TwitterShareButton, LinkedinShareButton } from 'react-share'
import { withTranslation } from 'react-i18next'

import './ArticleShare.css'

const ArticleShare = ({ t, description, title }) => {
    const url = window.location.href
    return (
        <div className="article-share">
            <h6>{t('singleArticle.share')}</h6>
            <div className="article-share__icons">
                <FacebookShareButton url={url}>
                    <img src="/images/fb.png" alt="facebook" />
                </FacebookShareButton>
                <TwitterShareButton url={url} title={title}>
                    <img src="/images/twitter.png" alt="twitter" />
                </TwitterShareButton>
                <LinkedinShareButton url={url} title={title} description={description}>
                    <img src="/images/linkedIn.png" alt="linkedIn" />
                </LinkedinShareButton>
            </div>
        </div>
    )
}

ArticleShare.propTypes = {
    t: PropTypes.func,
    description: PropTypes.string,
    title: PropTypes.string
}

export { ArticleShare }
export default withTranslation()(withRouter(ArticleShare))
